import {PerformanceRequest} from './performance-request';

export class PerformanceRequestMapper {

  public static mapRequests(assets: any[], testStartedAt: Date, resourceTimings: any[], pageLoadTime: number): PerformanceRequest[] {
    const urlResourceTimingMap: any = resourceTimings.reduce((map: any, resourceTiming: any): any => {
      map[resourceTiming.name] = resourceTiming;
      return map;
    });

    return assets.map((asset: any): PerformanceRequest => {
      return PerformanceRequestMapper.map(asset, testStartedAt, urlResourceTimingMap[asset.url], pageLoadTime);
    });
  }

  public static map(assetData: any, testStartedAt: Date, resourceTiming: any, pageLoadTime: number): PerformanceRequest {
    const performanceRequest: PerformanceRequest = new PerformanceRequest();

    performanceRequest.method = 'get'; // TODO:
    performanceRequest.url = assetData.url;
    performanceRequest.urlShort = assetData.url.split('/').reverse()[0];
    performanceRequest.status = assetData.status;
    performanceRequest.responseHeaders = Object.keys(assetData.headers.response).map((key: string): any => {
      return {
        key: key,
        value: assetData.headers.response[key]
      };
    });

    performanceRequest.fileSize = assetData.contentSize;
    performanceRequest.startOffset = resourceTiming ? resourceTiming.startTime : 0;
    performanceRequest.startTime = testStartedAt.getTime() + performanceRequest.startOffset;
    performanceRequest.duration = resourceTiming ? resourceTiming.duration : 0;
    performanceRequest.timelineChartData = [
      {
        startPercent: performanceRequest.startOffset / pageLoadTime * 100,
        percent: performanceRequest.duration / pageLoadTime * 100,
        color: '#71c242'
      }
    ];

    return performanceRequest;
  }

}
